import * as React from "react";

import HeroBan from "../../components/HeroBan";
import { useStaticQuery, graphql } from "gatsby";
import Layout from "../../components/layout";

const HotWater = ({ pageContext }) => {
  const wpdata = useStaticQuery(graphql`
    {
      wp {
        page(id: "residential/water-systems", idType: URI) {
          residentialHeatPumpWater {
            heroBackgroundColor
            heroContent
            heroHeading
            heroImage {
              altText
              sourceUrl
            }
            heroLink {
              target
              title
              url
            }
            summaryContent
            summaryLink {
              target
              title
              url
            }
            summaryImage {
              altText
              sourceUrl
              srcSet
            }
          }
        }
      }
    }
  `);
  const data = wpdata?.wp?.page?.residentialHeatPumpWater || {};

  return (
    <Layout pageContext={pageContext}>
      <HeroBan
        image={data?.heroImage?.sourceUrl}
        color={data?.heroBackgroundColor}
      >
        <h5>{data?.heroHeading}</h5>
        <p>{data?.heroContent}</p>
        <a href={data?.heroLink.url} target={data?.heroLink.target}>
          {data?.heroLink.title}
        </a>
      </HeroBan>
      <div className="flex flex-wrap lg:flex-nowrap max-w-7xl mx-auto py-24 w-11/12 md:w-4/5 lg:w-full xl:w-full 2xl:w-4/5 overflow-hidden text-black">
        <img
          alt={data?.summaryImage?.altText}
          src={data?.summaryImage?.sourceUrl}
        ></img>
        <div className="flex flex-col lg:mx-14">
          <p
            className="text-xl leading-9 lg:mt-0 mt-10 "
            dangerouslySetInnerHTML={{ __html: data?.summaryContent }}
          ></p>
          <a
            className="bg-tan text-xl text-black uppercase font-anton  px-20 py-3 mt-5 mr-auto"
            href={data?.summaryLink?.url}
            target={data?.summaryLink?.target}
          >
            {data?.summaryLink?.title}
          </a>
        </div>
      </div>
    </Layout>
  );
};

export default HotWater;
